const Asterisk = (props) => {
  return (
    <span style={{ color: '#ff0000' }}>*</span>
  );
};

export default Asterisk;